class CopyCurrentLink
{
  #copyLinkElements = null;
  #isCopied = false;

  constructor()
  {
    this.#copyLinkElements = document.querySelectorAll('[data-copy-link]');
  }

  init()
  {
    if(this.#copyLinkElements.length)
    {
      this.#copyLinkElements.forEach((link) => link.addEventListener('click', () => this.#copyLink(link)));
    }
  }

  #copyLink = (nodeElement) =>
  {
    if(!this.#isCopied)
    {
      navigator.clipboard.writeText(document.URL);
      this.#changeIcons(nodeElement);
      this.#isCopied = true;

      setTimeout(() =>
      {
        this.#isCopied = false;
        this.#changeIcons(nodeElement);
      }, 2000);
    }
  };

  #changeIcons = (element) =>
  {
    element.querySelector('[data-svg-default]').classList.toggle('visually-hidden');
    element.querySelector('[data-svg-copied]').classList.toggle('visually-hidden');
  };
}

const initCopyLinks = () =>
{
  const links = new CopyCurrentLink();
  links.init();
};

export { initCopyLinks };
